function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 23.3c-.4 0-.8-.3-.8-.8v-1.7a2.732 2.732 0 00-2.7-2.7h-6a2.732 2.732 0 00-2.7 2.7v1.7c0 .4-.3.8-.8.8s-.7-.3-.7-.8v-1.7c0-1.1.4-2.2 1.2-3 .8-.8 1.9-1.2 3-1.2h6c1.1 0 2.2.4 3 1.2.8.8 1.2 1.8 1.2 3v1.7c0 .5-.3.8-.7.8zM15.5 14.7c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2-1.9 4.2-4.2 4.2zm0-6.9c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7-1.2-2.7-2.7-2.7z"
});
function SvgClientsSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
}
export default SvgClientsSmall;